import type { SearchVariables } from '../../../common/constants/relay/types';

// Gets the variables for the search state.
export const getSearchVariables = (s: SearchVariables): SearchVariables => {
	return {
		searchQuery: s.searchQuery,
		originalQuery: s.originalQuery,
		resultsSort: s.resultsSort,
		filters: s.filters,
		selectedProducts: s.selectedProducts,
		selectedDatasource: s.selectedDatasource,
		jsmIncidentFilterIds: s.jsmIncidentFilterIds,
		paginationTokens: s.paginationTokens,
		availableProducts: s.availableProducts,
		requestId: s.requestId,
		traceId: s.traceId,
		cql: s.cql,
	};
};
